import { observer } from 'mobx-react-lite'
import { UpcomingConsultationPreview } from '@/features/jobs/list/components/UpcomingConsultationPreview'
import { type UpcomingConsultationPreviewViewModel } from '@/features/jobs/list/UpcomingConsultationPreviewViewModel'

export interface UpcomingConsultationPreviewContainerProps {
  vm: UpcomingConsultationPreviewViewModel
}

export const UpcomingConsultationPreviewContainer = observer(
  function UpcomingConsultationPreviewContainer({
    vm,
  }: UpcomingConsultationPreviewContainerProps) {
    if (!vm.isPro || !vm.areConsultationsUpcoming) return null

    return (
      <UpcomingConsultationPreview
        isExpanded={vm.isExpanded}
        upcomingConsultations={vm.filteredConsultations}
        onToggleExpanded={vm.toggleIsExpanded}
        onRowWidthChange={vm.setRowWidth}
      />
    )
  },
)
